import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Typography,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import {
  Email as EmailIcon,
  Campaign as CampaignIcon,
  Share as ShareIcon,
  LocalOffer as OfferIcon
} from '@mui/icons-material';
import EmailCampaigns from './EmailCampaigns';
import SocialMedia from './SocialMedia';
import Promotions from './Promotions';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index} style={{ paddingTop: '24px' }}>
      {value === index && children}
    </div>
  );
}

export default function Marketing() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Marketing Tools
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage email campaigns, social media, and promotional offers
        </Typography>
      </Box>

      <Paper sx={{ width: '100%', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            icon={<EmailIcon />}
            label="Email Campaigns"
            iconPosition="start"
          />
          <Tab
            icon={<ShareIcon />}
            label="Social Media"
            iconPosition="start"
          />
          <Tab
            icon={<OfferIcon />}
            label="Promotions"
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      <TabPanel value={activeTab} index={0}>
        <EmailCampaigns />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <SocialMedia />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <Promotions />
      </TabPanel>
    </Container>
  );
}
